import SelectController from "@/common/components/SelectController"
import TextField from "@/common/components/TextField"
import { Control, FieldErrors, UseFormRegister } from "react-hook-form"
import { CompanyBranchValidationSchema } from "../../schemas/createBranch.schema"
import { CompanyBranchData } from "@/common/types/companyBranches.type"
import { Mapper } from "@/common/services/mapper"
import useDebounce from "@/common/hooks/useDebounce"
import Checkbox from "@/common/components/Checkbox"
import { useAvailableCompanyBranches } from "../../hooks/companyBranches/useAvailableCompanyBranches"

export type BranchInformationProps = {
  branchId?: string
  register: UseFormRegister<CompanyBranchValidationSchema>
  errors: FieldErrors<CompanyBranchValidationSchema>
  control: Control<CompanyBranchValidationSchema, any>
  companyId?: string
  parentId?: string
  showParentIdField?: boolean
  billBy?: string
}

export const BranchInformation = ({
  branchId,
  register,
  errors,
  control,
  companyId,
  parentId,
  showParentIdField,
  billBy,
}: BranchInformationProps) => {
  const [searchCompanyBranch, setSearchCompanyBranch] = useDebounce("");

  const { data: companyBranchOptions } = useAvailableCompanyBranches({
    companyId,
    filters: {
      search: searchCompanyBranch,
    },
    mapper: Mapper.mapToOptions<CompanyBranchData>({ labelFieldName: 'display_name', valueFieldName: 'id' }),
  });

  return (
    <div className="flex flex-col gap-4">
      <div className="flex gap-2 w-full justify-between">
        <TextField
          label="Nome da filial"
          maxLength={64}
          errorMessage={errors.display_name?.message || undefined}
          className="w-full"
          disabled={!parentId}
          {...register('display_name')}
          markAsRequired
        />
        {showParentIdField && (
          <SelectController
            control={control}
            name="parent"
            label="Filial Mãe"
            className="w-full"
            errorMessage={errors?.parent?.message || undefined}
            options={
              branchId
                ? companyBranchOptions.filter((item) => item.value !== branchId) || []
                : companyBranchOptions || []
            }
            onInputChange={setSearchCompanyBranch}
            markAsRequired
          />
        )}
      </div>

      {billBy === 'dynamic_branch' && (
        <Checkbox
          label="Possui faturamento próprio"
          {...register('should_have_own_bill_when_dynamic')}
          errorMessage={errors.should_have_own_bill_when_dynamic?.message || undefined}
        />
      )}
    </div>
  )
}
